import React, { useState } from 'react';

import { getISO8601DateString } from '@aline/common';
import { isValid, parseISO } from 'date-fns';
import { AlineDatePicker } from 'src/components/generic';

interface ReminderDueDateProps {
  dueDate: string;
  onDueDateChange: (dueDate: string) => void;
}

export function ReminderDueDate({ dueDate, onDueDateChange }: ReminderDueDateProps) {
  const parsed = parseISO(dueDate);
  const dateValue = isValid(parsed) ? parsed : null;
  const [open, setOpen] = useState<boolean>(false);

  function handleDateChange(date: Date | null) {
    if (date) onDueDateChange(getISO8601DateString(date));
  }

  return (
    <AlineDatePicker
      open={open}
      placement="bottom-start"
      setOpen={setOpen}
      value={dateValue}
      onDateChange={handleDateChange}
    />
  );
}
